export default __webpack_public_path__ + "static/media/JejuMyeongjo.60b73f20.woff";